export enum CourseTypeDTO {
    Course = "Course",
    Package = "Package",
    LearningPath = "LearningPath"
}
